import { ALPHA_2_ISO_3166, SALUTATIONS } from 'cpool-constants';

import type { CreateApplicantFormValues } from '../schemaCreateApplicantForm';

export const defaultValues: CreateApplicantFormValues = {
    ausgaben: {
        mietausgaben: [],
        privateKrankenversicherungen: [],
        sonstigeAusgaben: [],
        unterhaltsverpflichtungen: [],
    },
    beschaeftigung: {
        beschaeftigungsart: null,
        steuerklasse: null,
    },
    // Credit type arrays
    dispositionskredite: [],
    einnahmen: {
        ehegattenunterhalt: [],
        einkuenfteAusKapitalvermoegen: [],
        einkuenfteAusNebentaetigkeit: [],
        sonstigeEinnahmen: [],
        unbefristeteZusatzrenten: [],
    },
    geschaeftskredite: [],
    immobilien: [],
    immobiliendarlehen: [],
    kinder: [],
    kontokorrentkredite: [],
    kreditkarten: [],
    leasings: [],
    personendaten: {
        anrede: SALUTATIONS.HERR,
        email: '',
        familienstand: null,
        geburtsdatum: null,
        geburtsland: ALPHA_2_ISO_3166.DE,
        geburtsname: null,
        geburtsort: null,
        nachname: '',
        staatsangehoerigkeit: ALPHA_2_ISO_3166.DE,
        telefonPrivat: '',
        vorname: '',
    },
    ratenkredite: [],
    sonstigeVerbindlichkeiten: [],
    wohnsituation: {
        anschrift: {
            hausnummer: null,
            land: null,
            ort: null,
            plz: null,
            strasse: null,
            wohnhaftSeit: null,
        },
        anzahlPersonenImHaushalt: null,
        anzahlPkw: null,
        gemeinsamerHaushalt: false,
        vorherigeAnschrift: {
            hausnummer: null,
            land: null,
            ort: null,
            plz: null,
            strasse: null,
            wohnhaftSeit: null,
        },
        wohnart: null,
        wohnflaeche: null,
    },
};
